// ==============================|| OVERRIDES - CHART AXIS HIGHLIGHT ||============================== //

export default function ChartsAxiasHighlight(theme) {
	return {
		MuiChartsAxisHighlight: {
			styleOverrides: {
				root: {
					stroke: theme.palette.secondary.light,
				},
			},
		},
	};
}
